export enum MenuTypeEnum {
  NOVEL = 'NOVEL',
  MANGA = 'MANGA',
  EBOOK = 'EBOOK',
  TOP_CHART_BOOK = 'TOP_CHART_BOOK',
  TOP_CHART_CHARACTER = 'TOP_CHART_CHARACTER',
  ARTICLE = 'ARTICLE',
}
